// src/App.js
import React, { Suspense, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";



// Component to scroll to top on route change
import Layout from "./components/Layout";
import HomeTwoScreen from "./pages/HomeTwoScreen";
import NotFound from "./pages/NotFound";
import LoanProgram from "./pages/LoanProgram";
import ContactUs from "./pages/ContactUs";
import Faqs from "./pages/Faqs";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
// import LoanProgramDetails from "./pages/LoanProgramDetails";
// import HomeOneScreen from "./pages/HomeOneScreen";
// import CalculateMortgage from "./pages/CalculateMortgage";
// import Management from "./pages/Management";
// import ManagementDetails from "./pages/ManagementDetails";
import AboutUs from "./pages/AboutUs";
import Blog from "./pages/Blog";
import BlogDetails from "./pages/BlogDetails";
import AdminLogin from "./pages/Admin/Login";
import AdminDashboard from "./pages/Admin/Dashboard";
import AdminBlogs from "./pages/Admin/Blogs";
import AdminBlogDetails from "./pages/Admin/BlogDetails";
import AdminRoute from "./components/AdminRoute";
import CanonicalUrl from "./components/CanonicalUrl";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
// BackToTop component
const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Show button when page is scrolled down
  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Scroll to top of page
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <button 
      type="button" 
      id="backtotop" 
      className={`fixed bottom-2 right-8 w-12 h-12 rounded-full bg-primary text-white flex items-center justify-center transition-all duration-300 ${isVisible ? 'opacity-100 visible' : 'opacity-0 invisible'}`}
      onClick={scrollToTop}
      aria-label="Back to top"
    >
      <i className="ri-upload-line"></i>
    </button>
  );
};
function App() {
  return (
    <BrowserRouter>
      <CanonicalUrl />
      <ScrollToTop />
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={
            <Layout>
              <HomeTwoScreen />
            </Layout>
          } />
          <Route path="/loan-program" element={
            <Layout>
              <LoanProgram />
            </Layout>
          } />
          <Route path="/about-us" element={
            <Layout>
              <AboutUs />
            </Layout>
          } />
          <Route path="/contact-us" element={
            <Layout>
              <ContactUs />
            </Layout>
          } />
          <Route path="/faqs" element={
            <Layout>
              <Faqs />
            </Layout>
          } />
          <Route path="/privacy-policy" element={
            <Layout>
              <PrivacyPolicy />
            </Layout>
          } />
          <Route path="/terms-and-conditions" element={
            <Layout>
              <TermsConditions />
            </Layout>
          } />
          {/* <Route path="/home-one" element={
            <Layout>
              <HomeOneScreen />
            </Layout>
          } /> */}
          
          {/* <Route path="/loan-program-details" element={
            <Layout>
              <LoanProgramDetails />
            </Layout>
          } /> */}            
          {/* <Route path="/calculate-mortgage" element={
            <Layout>
              <CalculateMortgage />
            </Layout>
          } /> */}
          {/* <Route path="/management" element={
            <Layout>
              <Management />
            </Layout>
          } />
          <Route path="/management-details" element={
            <Layout>
              <ManagementDetails />
            </Layout>
          } /> */}
          <Route path="/blog" element={
            <Layout>
              <Blog />
            </Layout>
          } />
          <Route path="/blog-details/:slug" element={
            <Layout>
              <BlogDetails />
            </Layout>
          } />
          
          {/* Admin Routes */}
          <Route path="/admin" element={<AdminRoute><AdminLogin /></AdminRoute>} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
          <Route path="/admin/blogs" element={<AdminRoute><AdminBlogs /></AdminRoute>} />
          <Route path="/admin/blog-details/:slug" element={<AdminRoute><AdminBlogDetails /></AdminRoute>} />
          
          {/* 404 Page */}
          <Route path="/404" element={
            <Layout>
              <NotFound />
            </Layout>
          } />
          
          {/* Catch-all route for undefined paths */}
          <Route path="*" element={<Navigate to="/404" replace />} />
        </Routes>
      </Suspense>
      <BackToTop />
    </BrowserRouter>
  );
}

export default App;
